import { render, staticRenderFns } from "./DependentDetails.vue?vue&type=template&id=132e0b78&"
import script from "./DependentDetails.vue?vue&type=script&lang=js&"
export * from "./DependentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports